import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, RootContext, Wrapper } from '@skylab-angular-shared/core';
import { AccountancyEntriesQuery, AccountancyEntriesQueryHandlerBase } from '@skylab-shared/business';
export { AccountancyEntriesQueryHandlerBase };

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(AccountancyEntriesQuery)
@Wrapper(AccountancyEntriesQueryHandlerBase)
export class AccountancyEntriesQueryHandler {
    public constructor(
        http: Http,
        rootContext: RootContext
    ) { }
}
